// Company/Brand Information
export const BRAND_INFO = {
  name: "Style Buzz Pro",
  website: "https://www.stylebuzzpro.com",
  email: "contact@stylebuzzpro.com",
  gstin: "29AACFZ5858M1ZB",
  address: "Bangalore Karnataka India",
};

// Footer Information
export const FOOTER_INFO = {
  copyright: `© ${new Date().getFullYear()} ${
    BRAND_INFO.name
  }. All rights reserved.`,
  note: "Thank you for choosing Style Buzz Pro - Where Style Meets Excellence!",
  privacyText:
    "By using our services, you agree to our Terms of Service and Privacy Policy.",
};

// Social Media Links
export const SOCIAL_LINKS = {
  facebook: "https://facebook.com/stylebuzzpro",
  instagram: "https://instagram.com/stylebuzzpro",
  twitter: "https://twitter.com/stylebuzzpro",
};

// Contact Information
export const CONTACT_INFO = {
  phone: "+91 123-456-7890",
  supportEmail: "support@stylebuzzpro.com",
  businessHours: "Mon-Sat: 9:00 AM - 8:00 PM",
};

// App Configuration
export const APP_CONFIG = {
  currency: "₹",
  dateFormat: "DD/MM/YYYY",
  timeFormat: "hh:mm A",
  defaultLanguage: "en",
};
